module.exports = __webpack_public_path__ + "img/ic_insta.7e0fc28e.svg";